// import Repository from "./repository"
import RepositoryHealth from "./repository.healthportal"

// const resource = 'users'
const resourceHealth = 'patient'

const users = [
    {
        "id": "1",
        "name": "Jaime",
        "subnames": "Maceiras",
        "cedula": "1-123-123",
        "passport": "PAE060432",
        "country": "Panama",
        "birth-date": "15/04/1966",
        "birth-place": "Panama",
        "cedula-renovation-date": "10/08/2022",
        "health": {
            "height": "190",
            "weight": "82",
            "chronic-diseases": [
                "Migraña",
                "Hipertensión"
            ]
        }
    },
    {
        "id": "2",
        "name": "Diego",
        "subnames": "Rodríguez",
        "cedula": "2-123-123",
        "passport": "PE153375",
        "country": "Panama",
        "birth-date": "20/10/1972",
        "birth-place": "Panama",
        "cedula-renovation-date": "10/08/2021",
        "health": {
            "height": "182",
            "weight": "76",
            "chronic-diseases": []
        }
    },
    {
        "id": "3",
        "name": "Jose",
        "subnames": "Ramírez",
        "cedula": "1-111-111",
        "passport": "PASAPORTE-JOSE",
        "country": "Panama",
        "birth-date": "12/07/1990",
        "birth-place": "Panama",
        "cedula-renovation-date": "09/07/2021",
        "health": {
            "height": "185",
            "weight": "74",
            "chronic-diseases": [
                "Migraña"
            ]
        }
    },
    {
        "id": "4",
        "name": "Prueba",
        "subnames": "Prueba",
        "cedula": "1111111",
        "passport": "PAE160334",
        "country": "Panama",
        "birth-date": "17/08/1986",
        "birth-place": "Panama",
        "cedula-renovation-date": "12/09/2023",
        "health": {
            "height": "192",
            "weight": "87",
            "chronic-diseases": [
                "Migraña"
            ]
        }
    }
];

export default {
    async getUserInfo({ identifier }) {
        // TODO create a call to API and return the user info
        let user = users.find(u => u.cedula === identifier);

        if (user === undefined) {
            user = users.find(u => u.passport === identifier);
        }

        return user;
    },
    async getPatientHealth({ identificationType, identification }) {
        let endpoint = `${resourceHealth}/health/${identificationType}/${identification}`;
        let response = await RepositoryHealth.get(endpoint);
        return response;
    }
}